let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fcDu7")).then(() => parcelRequire('4XouL'));